angular.module('bb.listing_view').directive('listingViewCarousel', () => {
  return {
    restrict: 'E',
    scope: {
      assets: '=',
      listingId: '=',
      shouldOpenModal: '=',
      showButtons: '=',
      isCoopAgent: '=',
    },
    controller: listingCarouselController,
    bindToController: true,
    controllerAs: 'vm',
    template: require('./listing_view_carousel.html'),
  };
});

listingCarouselController.$inject = [
  'ModalService',
  '$scope',
  '$timeout',
  '$rootScope',
];
function listingCarouselController(ModalService, $scope, $timeout, $rootScope) {
  const vm = this;

  let half = $(`#${vm.ID}`).width() / 2;
  let panning = false;

  // generate a random id for the maps so that ngMap knows
  // which instance to grab.
  vm.ID = `asset-${Math.random().toString(36).substr(2, 9)}`;

  vm.isFavorite =
    $rootScope.favorites && $rootScope.favorites.has(vm.listingId);
  $rootScope.$watch('favorites', newValue => {
    vm.isFavorite = newValue?.has(vm.listingId);
  });

  vm.canScrollRight = function () {
    return (
      $(`#${vm.ID}`).scrollLeft() <
        $(`#${vm.ID}`)[0].scrollWidth - $(`#${vm.ID}`).width() ||
      $(`#xs-${vm.ID}`).scrollLeft() <
        $(`#xs-${vm.ID}`)[0].scrollWidth - $(`#xs-${vm.ID}`).width()
    );
  };

  vm.canScrollLeft = function () {
    return (
      $(`#${vm.ID}`).scrollLeft() > 0 || $(`#xs-${vm.ID}`).scrollLeft() > 0
    );
  };

  vm.hideLeft = true;
  vm.hideRight = false;

  $timeout(function () {
    if ($(`#${vm.ID}`)[0] === undefined && $(`#xs-${vm.ID}`)[0] === undefined) {
      return;
    }

    if (
      $(`#${vm.ID}`)[0].scrollWidth === 0 &&
      $(`#xs-${vm.ID}`)[0].scrollWidth === 0
    ) {
      return;
    }
    vm.hideLeft = !vm.canScrollLeft();
    vm.hideRight = !vm.canScrollRight();
  }, 1000);

  vm.toggleFavorite = function () {
    $rootScope.toggleFavorite(vm.listingId);
  };

  vm.firstHalf = function () {
    if (!vm.assets) return [];
    const assets = vm.assets.slice(1);
    const { length } = assets;
    return assets.slice(0, Math.ceil(length / 2));
  };

  vm.secondHalf = function () {
    if (!vm.assets) return [];
    const assets = vm.assets.slice(1);
    const { length } = assets;
    return assets.slice(Math.ceil(length / 2), length);
  };

  vm.panRight = function () {
    half = $(`#${vm.ID}`).width() / 2;
    const assetSize = $(`#xs-${vm.ID}`).width();

    if (vm.canScrollRight() && !panning) {
      panning = true;
      $(`#${vm.ID}`).animate(
        { scrollLeft: `+=${half}` },
        500,
        'easeOutQuart',
        function () {
          panning = false;
          vm.hideLeft = !vm.canScrollLeft();
          vm.hideRight = !vm.canScrollRight();
          $scope.$apply();
        },
      );
      $(`#xs-${vm.ID}`).animate(
        { scrollLeft: `+=${assetSize}` },
        500,
        'easeOutQuart',
        function () {
          panning = false;
          vm.hideLeft = !vm.canScrollLeft();
          vm.hideRight = !vm.canScrollRight();
          $scope.$apply();
        },
      );
    } else {
      vm.hideLeft = !vm.canScrollLeft();
      vm.hideRight = !vm.canScrollRight();
    }
  };

  vm.panLeft = function () {
    half = $(`#${vm.ID}`).width() / 2;
    const assetSize = $(`#xs-${vm.ID}`).width();
    if (vm.canScrollLeft() && !panning) {
      panning = true;
      $(`#${vm.ID}`).animate(
        { scrollLeft: `-=${half}` },
        500,
        'easeOutQuart',
        function () {
          panning = false;
          vm.hideLeft = !vm.canScrollLeft();
          vm.hideRight = !vm.canScrollRight();
          $scope.$apply();
        },
      );
      $(`#xs-${vm.ID}`).animate(
        { scrollLeft: `-=${assetSize}` },
        500,
        'easeOutQuart',
        function () {
          panning = false;
          vm.hideLeft = !vm.canScrollLeft();
          vm.hideRight = !vm.canScrollRight();
          $scope.$apply();
        },
      );
    }
  };

  vm.openAssets = function (index) {
    if (!vm.shouldOpenModal) return;
    ModalService.openAssetModal({ index, assets: vm.assets });
  };
}
